module.exports = __webpack_public_path__ + "img/fiturManajemen.f649797d.png";